import type { Store } from '@/lib/types';

interface SwitcherProps {
  stores: Store[];
  onSelect: (storeId: string) => void;
}

export function Switcher({ stores, onSelect }: SwitcherProps) {
  const regions: { name: string; stores: Store[] }[] = [];
  for (const store of stores) {
    const region = regions.find((r) => r.name === store.region);
    if (region) region.stores.push(store);
    else regions.push({ name: store.region, stores: [store] });
  }

  return (
    <div className="app-scroll h-full px-[18px] pb-10 pt-[26px]" style={{ flex: '0 0 33.3333%' }}>
      <div className="mb-[22px] text-[22px] font-extrabold leading-[normal] text-ink">Stores</div>
      {regions.map((region) => (
        <div key={region.name} className="mb-[22px]">
          <div className="mx-0.5 mb-2.5 text-[11px] font-bold uppercase tracking-[.1em] text-faint">
            {region.name}
          </div>
          <div className="flex flex-col gap-[9px]">
            {region.stores.map((store) => (
              <div
                key={store.id}
                onClick={() => onSelect(store.id)}
                className="flex cursor-pointer items-center gap-3 rounded-card bg-card p-4 shadow-soft hover:bg-hov"
              >
                <div className="min-w-0 flex-1">
                  <div className="text-base font-bold text-ink">{store.name}</div>
                  <div className="mt-0.5 text-xs font-semibold text-faint">
                    {store.cartCount} carts
                  </div>
                </div>
                <div className="text-[17px] font-bold text-muted">›</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
